export default "__VITE_ASSET__1PWdPSr3__"